import moment from 'moment';
import { Heading } from '@lendi-ui/typography';

import { EmploymentEntityIndex } from '@funnels/types';
import { FunnelGridUnit } from '@funnels/ui-components/Common';
import {
  EmploymentBasis,
  EmploymentEndDate,
  EmploymentOnProbation,
  EmploymentRole,
  EmploymentStartDate,
  EmploymentType,
  ReturnToWorkBasis,
  ReturnToWorkDate,
} from '@funnels/ui-components/Employment';

export const isDateValid = (date: string) => moment(date).isValid();
export const isLessThanAYear = (date: string) =>
  isDateValid(date) &&
  moment().diff(moment(date), 'years', true) >= 0 &&
  moment().diff(moment(date), 'years', true) <= 1;

interface EmploymentDetailsProps extends EmploymentEntityIndex {
  isWorking?: boolean;
  isSelfEmployed?: boolean;
  isPreviousRole?: boolean;
  isSecondaryRole?: boolean;
  isOnMaternityLeave?: boolean;
  isOnProbation?: boolean;
  startDate?: string;
}

export const EmploymentDetails = (props: EmploymentDetailsProps) => {
  const {
    employmentIndex,
    isWorking,
    isSelfEmployed,
    isPreviousRole,
    isSecondaryRole,
    isOnMaternityLeave,
    isOnProbation,
    startDate,
  } = props;

  return (
    <>
      <FunnelGridUnit mb="md" mt="xl">
        <Heading size="xs">Employment details</Heading>
      </FunnelGridUnit>
      {isPreviousRole && (
        <FunnelGridUnit mb="md">
          <EmploymentType employmentIndex={employmentIndex} shouldHideNotWorkingOption={isSecondaryRole} />
        </FunnelGridUnit>
      )}
      {isWorking && (
        <FunnelGridUnit mb="md">
          <EmploymentRole employmentIndex={employmentIndex} isOptional />
        </FunnelGridUnit>
      )}
      {isWorking && (
        <FunnelGridUnit mb="md">
          <EmploymentBasis employmentIndex={employmentIndex} shouldHideMaternityLeaveOption={isPreviousRole} />
        </FunnelGridUnit>
      )}
      <FunnelGridUnit mb="md">
        <EmploymentStartDate employmentIndex={employmentIndex} />
        {isWorking && !isSelfEmployed && !!startDate && isLessThanAYear(startDate) && (
          <EmploymentOnProbation employmentIndex={employmentIndex} isChecked={isOnProbation} />
        )}
      </FunnelGridUnit>
      {isPreviousRole && (
        <FunnelGridUnit mb="md">
          <EmploymentEndDate employmentIndex={employmentIndex} startDate={startDate} />
        </FunnelGridUnit>
      )}
      {isOnMaternityLeave && (
        <FunnelGridUnit mb="md">
          <ReturnToWorkDate employmentIndex={employmentIndex} />
        </FunnelGridUnit>
      )}
      {isOnMaternityLeave && (
        <FunnelGridUnit mb="md">
          <ReturnToWorkBasis employmentIndex={employmentIndex} />
        </FunnelGridUnit>
      )}
    </>
  );
};
